'use client';

import ArticleDetail from '@/components/article-detail';
import { ContactBreadcrumbItems } from '@/data/globals.data';

export default function Client() {
  return <ArticleDetail breadcrumbItems={ContactBreadcrumbItems} />;
}
